// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { LayersEnum } from "../../Chart/Renderers/TerceraChartBaseRenderer.ts";
import { DataCacheToolToolType } from "../../Commons/cache/DataCacheToolEnums.js";
import { TerceraChartAction, TerceraChartActionEnum } from "../../Chart/TerceraChartAction.js";
import { TerceraButton } from "./TerceraButton.js";
import { TerceraToolStrip } from "./TerceraToolStrip.js";
import { ThemeManager } from "../misc/ThemeManager.js";

export let TerceraChartToolsPanel = TerceraToolStrip.extend({
    data: function ()
    {
        return {
            actionProcessor: null,
            canCheck: true,
            itemWidth: 27,
            itemHeight: 27,
            itemHorMargin: 3,
            popupMaxColumns: 9,
            terceraButtonStyle: TerceraButton.TerceraButtonStyle.ChartToolButton
        };
    }
});

TerceraChartToolsPanel.prototype.oninit = function ()
{
    TerceraToolStrip.prototype.oninit.apply(this);

    this.observe('actionProcessor',
        this.onActionProcessorChanged,
        { init: false });
};

TerceraChartToolsPanel.prototype.createDefaultItems = function ()
{
    var callback = this.onToolStripItemClicked.bind(this);
    return [
        { visible: true, name: 'Cancel', type: TerceraChartAction.Create(TerceraChartActionEnum.Cancel), event: callback },

        { visible: true, name: 'ToolSelector', type: TerceraChartAction.Create(TerceraChartActionEnum.ToolSelector), event: callback },
        //{ visible: true, name: 'Eraser', type: TerceraChartAction.Create(TerceraChartActionEnum.Eraser), event: callback },

        { name: 'separator' },

        { visible: true, name: 'SnapToCandle', type: TerceraChartAction.Create(TerceraChartActionEnum.SnapToCandle), event: callback },
        { visible: true, name: 'SetStayInDrawingMode', type: TerceraChartAction.Create(TerceraChartActionEnum.SetStayInDrawingMode), event: callback },

        { name: 'separator' },

        // Lines tools   
        { visible: true, name: 'Line', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Line), event: callback },
        { visible: true, name: 'VerticalLine', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.VerticalLine), event: callback },
        { visible: true, name: 'HorizontalLine', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.HorizontalLine), event: callback },
        { visible: true, name: 'Triangle', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Triangle), event: callback },
        { visible: true, name: 'Rectangle', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Rectangle), event: callback },
        { visible: true, name: 'Polygon', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Polygon), event: callback },
        { visible: true, name: 'Circle', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Circle), event: callback },
        { visible: true, name: 'Ellipse', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Ellipse), event: callback },
        { visible: true, name: 'AndrewsPitchFork', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.AndrewsPitchFork), event: callback },
        { visible: true, name: 'PriceChannel', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.PriceChannel), event: callback },

        { name: 'separator' },

        // Fibonacci     
        { visible: true, name: 'FibonacciRetracement', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciRetracement), event: callback },
        { visible: true, name: 'FibonacciExpansion', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciExpansion), event: callback },
        { visible: true, name: 'FibonacciArc', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciArc), event: callback },
        { visible: true, name: 'FibonacciEllipse', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciEllipse), event: callback },
        { visible: true, name: 'FibonacciSpiral', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciSpiral), event: callback },
        { visible: true, name: 'FibonacciFans', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciFans), event: callback },
        { visible: true, name: 'FibonacciPhiChannel', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciPhiChannel), event: callback },
        { visible: true, name: 'FibonacciTimeGoal', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciTimeGoal), event: callback },
        { visible: true, name: 'FibonacciTimeZone', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.FibonacciTimeZone), event: callback },

        { name: 'separator' },

        // Gann          
        { visible: true, name: 'GannLine', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.GannLine), event: callback },
        { visible: true, name: 'GannFan', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.GannFan), event: callback },
        { visible: true, name: 'GannGrid', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.GannGrid), event: callback },

        { name: 'separator' },

        // Elliott  W_ave         
        { visible: true, name: 'ElliottImpulse', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ElliottImpulse), event: callback },
        { visible: true, name: 'ElliottCorrection', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ElliottCorrection), event: callback },
        { visible: true, name: 'ElliottTriangle', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ElliottTriangle), event: callback },
        { visible: true, name: 'ElliottTripleCombo', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ElliottTripleCombo), event: callback },
        { visible: true, name: 'ElliottDoubleCombo', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ElliottDoubleCombo), event: callback },

        { name: 'separator' },

        { visible: true, name: 'InfoLine', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.InfoLine), event: callback },
        /*{ visible: true, name: 'Symbol', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Symbol), event: callback },
        { visible: true, name: 'Text', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.Text), event: callback },

        { name: 'separator' },

        { visible: true, name: 'DeleteSelectedTools', type: TerceraChartAction.Create(TerceraChartActionEnum.DeleteSelectedTools), event: callback },
        { visible: true, name: 'SelectedToolSettings', type: TerceraChartAction.Create(TerceraChartActionEnum.SelectedToolSettings), event: callback },
        { visible: true, name: 'ToolColor', type: TerceraChartAction.Create(TerceraChartActionEnum.ToolColor), event: callback },
        { visible: true, name: 'ToolLineWidth', type: TerceraChartAction.Create(TerceraChartActionEnum.ToolLineWidth), event: callback },

        { visible: true, name: 'RegressionChanel', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.RegressionChanel), event: callback },
        { visible: true, name: 'ABCPatern', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ABCPatern), event: callback },
        { visible: true, name: 'PPZ', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.PPZ), event: callback },
        { visible: true, name: 'TopBottomPattern', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.TopBottomPattern), event: callback },
        { visible: true, name: 'ButterflyGartley', type: TerceraChartAction.Create(TerceraChartActionEnum.CreationTool, DataCacheToolToolType.ButterflyGartley), event: callback }*/

        { name: 'separator' },

        { visible: true, name: 'DeleteHoverAndSelectedTools', type: TerceraChartAction.Create(TerceraChartActionEnum.DeleteHoverAndSelectedTools), event: callback }
    ];
};

TerceraChartToolsPanel.prototype.onActionProcessorChanged = function (newProc, oldProc)
{
    if (oldProc)
        oldProc.StateChanged.UnSubscribe(this.updateToolbar, this);
    if (newProc)
        newProc.StateChanged.Subscribe(this.updateToolbar, this);

    if (!newProc)
        return;

    this.updateToolbar();
};

TerceraChartToolsPanel.prototype.updateToolbar = function ()
{
    var actionProcessor = this.get('actionProcessor');
    if (!actionProcessor) return;

    var toolStripItems = this.get('toolStipItems');
    // First init for optimization purposes.
    if (!toolStripItems) toolStripItems = this.createDefaultItems();

    var len = toolStripItems.length;
    for (var i = 0; i < len; i++)
    {
        var tsItem = toolStripItems[i];
        if (tsItem.name === 'separator')
            continue;

        var action = tsItem.type;
        var state = actionProcessor.GetTerceraChartActionState(action);

        tsItem.active = state.Active;
        tsItem.enabled = state.Enabled;
        tsItem.visible = state.Visible;
        tsItem.tooltip = state.locKey;
        tsItem.image = ThemeManager.getImageFullUrl(state.ImageKey);
        tsItem.imageChecked = ThemeManager.getImageFullUrl(state.ImageCheckedKey)
    }
    actionProcessor.chart.IsDirty(LayersEnum.Tools);
    this.set('toolStipItems', toolStripItems);
};

TerceraChartToolsPanel.prototype.onToolStripItemClicked = function (action)
{
    this.get('actionProcessor').ProcessTerceraChartAction(action);
};

TerceraChartToolsPanel.prototype.dispose = function ()
{
    TerceraToolStrip.prototype.dispose.apply(this);

    var actionProcessor = this.get('actionProcessor');
    if (actionProcessor)
        actionProcessor.StateChanged.UnSubscribe(this.updateToolbar, this);
};

TerceraChartToolsPanel.prototype.themeChange = function ()
{
    this.updateToolbar();
};